import { invokeIfExists, rm } from 'utils';
import { StockStatus, Time, CarriageMethod } from 'models/ProductMeta';
import { SaleStatus } from 'models/SaleStatus';
import {
  ListViewProduct,
  IWidget,
  WidgetType,
  MediaWidget,
  BrandWidget,
  TopTestedWidget
} from 'models/ListViewProduct';

export const mapStockStatus = (e: StockStatus) =>
  invokeIfExists(
    {
      [StockStatus.Storage]: () => rm('delivery_stockstatus_storage'),
      [StockStatus.Order]: () => rm('delivery_stockstatus_order'),
      [StockStatus.Create]: () => rm('delivery_stockstatus_create'),
      [StockStatus.End]: () => rm('delivery_stockstatus_end')
    },
    e,
    rm('delivery_enum_notdefined')
  );

export const mapSaleStatus = (e: SaleStatus, isNew: boolean) =>
  invokeIfExists(
    {
      [SaleStatus.Expired]: () => rm('delivery_salestatus_expired'),
      [SaleStatus.NotInStock]: () =>
        isNew ? rm('delivery_salestatus_notinstock_isnew') : rm('delivery_salestatus_notinstock'),
      [SaleStatus.InStock]: () => rm('delivery_salestatus_instock'),
      [SaleStatus.Active]: () => rm('delivery_salestatus_active'),
      [SaleStatus.InActive]: () => rm('delivery_salestatus_inactive')
    },
    e,
    rm('delivery_enum_notdefined')
  );

export const mapTime = (e: Time) =>
  invokeIfExists(
    {
      [Time.TwoToThreeWorkDays]: () => rm('delivery_time_twotothreeworkdays'),
      [Time.TwoToFiveWorkDays]: () => rm('delivery_time_twotofiveworkdays'),
      [Time.ThreeToFiveWorkDays]: () => rm('delivery_time_threetofiveworkdays'),
      [Time.FiveToTenWorkDays]: () => rm('delivery_time_fivetotenworkdays'),
      [Time.TwoToFourWeeks]: () => rm('delivery_time_twotofourweeks'),
      [Time.FourToSixWeeks]: () => rm('delivery_time_fourtosixweeks'),
      [Time.SixToEightWeeks]: () => rm('delivery_time_sixtoeightweeks'),
      [Time.EightToTenWeeks]: () => rm('delivery_time_eighttotenweeks'),
      [Time.TenToTwelveWeeks]: () => rm('delivery_time_tentotwelveweeks'),
      [Time.TwelveToFourteenWeeks]: () => rm('delivery_time_twelvetofourteenweeks'),
      [Time.FourteenToSixteenWeeks]: () => rm('delivery_time_fourteentosixteenweeks'),
      [Time.TwoToThreeWeeks]: () => rm('delivery_time_twotothreeweeks'),
      [Time.ThreeToFourWeeks]: () => rm('delivery_time_threetofourweeks'),
      [Time.FourToSevenWorkDays]: () => rm('delivery_time_fourtosevenworkdays')
    },
    e,
    rm('delivery_enum_notdefined')
  );

export const mapCarriageMethod = (e: CarriageMethod) =>
  invokeIfExists(
    {
      [CarriageMethod.NotDefined]: () => rm('delivery_enum_notdefined'),
      [CarriageMethod.Home]: () => rm('delivery_type_home'),
      [CarriageMethod.Away]: () => rm('delivery_type_away'),
      [CarriageMethod.Special]: () => rm('delivery_type_special'),
      [CarriageMethod.HomeSpecial]: () => rm('delivery_type_homespecial'),
      [CarriageMethod.AwaySpecial]: () => rm('delivery_type_awayspecial'),
      [CarriageMethod.HomeDeliveryOptions]: () => rm('delivery_type_homedeliveryoptions'),
      [CarriageMethod.AwayDeliveryOptions]: () => rm('delivery_type_awaydeliveryoptions'),
      [CarriageMethod.Letter]: () => rm('delivery_type_letter')
    },
    e,
    rm('delivery_enum_notdefined')
  );

export type WidgetSelector<T extends IWidget> = ({
  widgets
}: Pick<ListViewProduct, 'widgets'>) => T | undefined;
const getWidget =
  <T extends IWidget>(type: WidgetType): WidgetSelector<T> =>
  ({ widgets = [] }) => {
    const widget = widgets.find(widget => widget.type === type);
    if (widget) {
      return widget as T;
    }
    return undefined;
  };

export const getMediaWidget = getWidget<MediaWidget>(WidgetType.Media);
export const getBrandWidget = getWidget<BrandWidget>(WidgetType.Brand);
export const getIsTopTested = getWidget<TopTestedWidget>(WidgetType.TopTested);

type TitleSplitProps = Pick<ListViewProduct, 'title'> &
  Partial<Pick<ListViewProduct, 'titleSplitPos'>>;
const getTitleSplitPos = ({ titleSplitPos, title }: TitleSplitProps) =>
  titleSplitPos || Math.max(title.indexOf(' '), 0);

export const splitTitle = (props: TitleSplitProps): { title: string; category?: string } => {
  const pos = getTitleSplitPos(props);
  if (pos > 0) {
    return {
      title: props.title.substr(pos).trim(),
      category: props.title.substr(0, pos).trim()
    };
  }
  return { title: props.title };
};
